
const aboutStepConfig = {
    component: () => import('./AboutStep'),
    hideCartLink: true
};

export default aboutStepConfig;
